// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import colors from "@gcg/XDL/PreStyle/colors";
import { xBaseTheme } from "@gcg/XDL/types";
import TooltipPropsDefault from "@insite/mobius/Tooltip/presentationProps";
import { get } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css } from "styled-components";

/**
 * Notes:
 *  * We need z-index to make tooltip show above some components like Tab header
 */
export default {
    defaultProps: {
        ...TooltipPropsDefault,
        cssOverrides: {
            tooltipContainer: css`
                z-index: 432;
                background: ${getColor("common.background")};
                box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);

                &::after {
                    border-color: ${getColor("common.background")} transparent transparent transparent;
                }
            `,
            tooltipBody: css`
                padding: 25px 20px;
                border-radius: 0;
                background: ${getColor("common.background")};
            `,
        },
        typographyProps: {
            color: "text.main",
            size: 14,
        },
    },
} as xBaseTheme["tooltip"];
